import React from 'react'
import Header2 from '../Coman/Header2'
import Hero from './Hero'
import Main from './Main'
import Creators from './Creators'
import Innovative from './Innovative'
import Resource from './Resource'
import Footer2 from '../Coman/Footer2'
import Unleash from './Unleash'
import Pricing from './Pricing'
import FAQ from './FAQ'
import Contact from './Contact'
import TON from './TON'
import Roadmap from './Roadmap'

export default function Index() {
  return (
    <div style={{ overflow: 'hidden', position: 'relative' }}>
      <Header2 />
      <Hero />
      <Creators />
      <Innovative />
      <Main />
      <TON />
      <Resource />
      <Unleash />
      <Roadmap/>
      {/* <Pricing /> */}
      <Contact />
      <FAQ />
      <Footer2 />
    </div>
  )
}
